<template>
  <div style="margin-top: 1%; padding-bottom: 2%">
    Dear A. Jones,<br /><br />

    I am addressing you personally as I have been told that you are the person
    in charge of ATCL's 5G project in North America. I would like to bring the
    following points to your attention in this regard:<br /><br />

    For several years, the Corona pandemic has kept the world on tenterhooks.
    Wuhan was the first 5G model city in the world - frequencies above 20 GHz
    were available there for the first time. At 20 GHz, hydrogen goes into
    resonance, decoupling from all molecules. There is solid evidence that this
    highly damaging radiation is related to the formation of Covid-19.<br /><br />

    Furthermore, there are repeated reports of mass bird deaths occurring
    regularly near transmission towers for the 5G network in various countries
    around the world. It is inconceivable that 150 pastoral starlings would
    randomly all die in the same place at the same second, as was the case
    recently in Sydney, for example. In Australia, 80% of the population is
    already connected to 5G.<br /><br />

    5G is a health risk to humans. It has been proven for many years that
    electromagnetic radiation damages our DNA and causes cancer. This is called
    ionizing radiation. There are countless publications on this from renowned
    scientific journals.<br /><br />

    I therefore implore you to stop the 5G project immediately, as it is a
    danger to the life and limb of all of us.<br /><br />

    Respectfully,<br />

    Prof. Peter Malcolm
  </div>
</template>

<script>
import "./styles.css";

export default {
  props: {
    parentFunction: Function,
  },
};
</script>
